import {
  FinalSubmissionPayload,
  UnbilledShipmentsFilters,
  UnbilledShipmentsResponse,
} from '@Components/PurchaseInvoiceCreation/types';
import API from '@Services/apiAxios';

export const fetchUnbilledPurchaseShipments = async (
  filters?: UnbilledShipmentsFilters,
): Promise<UnbilledShipmentsResponse> => {
  const body: Record<string, any> = {};

  if (filters?.fromDate) body.fromDate = filters.fromDate;
  if (filters?.toDate) body.toDate = filters.toDate;
  if (filters?.carriers?.length) body.carriers = filters.carriers;
  if (filters?.systems?.length) body.systems = filters.systems;

  const res = await API.post<UnbilledShipmentsResponse>('invoice/purchase-invoice/unbilled-purchase-shipments', body);

  return res.data;
};

export const getCarriers = async () => {
  const res = await API.get('/organization/carrier');
  return res.data?.data || [];
};

export const createPurchaseInvoice = async (data: FinalSubmissionPayload) => {
  try {
    const payload = {
      shipmentNumbers: data.awbs.map(a => a.number),
      carrierId: data.carrier.id,
      billDate: data.invoiceDate,
      dueDate: data.dueDate,
      carrierReferenceNumber: data.carrierReferenceNumber,
    };

    const response = await API.post('/invoice/purchase-invoice/create-purchase-invoice', payload);
    return response.data;
  } catch (error: any) {
    console.error('Invoice Submission Error:', error.response?.data || error.message);
    throw error;
  }
};

export const createD365PurchaseInvoice = async (data: FinalSubmissionPayload) => {
  try {
    const payload = {
      shipmentNumbers: data.awbs.map(a => a.number),
      carrierId: data.carrier.id,
      billDate: data.invoiceDate,
      dueDate: data.dueDate,
      carrierReferenceNumber: data.carrierReferenceNumber,
    };
    const response = await API.post('/invoice/purchase-invoice/d365/create-purchase-invoice', payload);
    return response.data;
  } catch (error: any) {
    console.error('Invoice Submission Error:', error.response?.data || error.message);
    throw error;
  }
};
